<div class="states-editor">
    <div class="states-editor-list">
        <eas-workflow-states-list-item *ngFor="let item of states; first as isFirst; last as isLast"
                                      [item]="item"
                                      [availableRoles]="availableRoles"
                                      [isLast]="isLast"
                                      [isFirst]="isFirst"
                                      (editState)="onEdit($event)">
        </eas-workflow-states-list-item>
    </div>
</div>
